// IMP-234 — useRayCodes 공용 훅
// RayCodeReducer.items 를 단일 store 에서 관리하면서, 호출자별로 분산 mount-fetch 하던
// 패턴(BUG-090 옵션 B)의 누락 회귀를 구조적으로 차단한다.
// GetAll 은 현재 로컬 raycode.json 동기 dispatch(비용 0). idempotent 가드로 중복 fetch 방지.

import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RayCodeAction } from '../../actions/RayCodeAction';

export const useRayCodes = (type) => {
    const dispatch = useDispatch();
    const items = useSelector((state) => state.RayCodeReducer?.items);
    // deps 에 items 포함은 의도적: store 가 외부에서 비워지면(items=[]/비배열) 자동 재fetch 하여
    // BUG-090 류의 "코드 목록 누락" 회귀를 구조적으로 차단한다. items 가 채워진 뒤에는 가드
    // 조건이 false 가 되어 재dispatch 가 막히므로 무한 fetch 루프는 발생하지 않는다.
    useEffect(() => {
        if (!Array.isArray(items) || items.length === 0) {
            dispatch(RayCodeAction.GetAll());
        }
    }, [dispatch, items]);
    // useMemo: items/type 가 동일하면 동일 배열 참조 반환 → 소비자의 useEffect([codes]) 가
    // 매 렌더 발화하지 않도록(무한 루프/불필요 재계산 차단). clist prop→local-state 동기화
    // 패턴의 drop-in 대체를 위해 참조 안정성 보장.
    return useMemo(() => {
        const safe = Array.isArray(items) ? items : [];
        return type ? safe.filter((x) => x?.type === type) : safe;
    }, [items, type]);
};
